import { Enfant } from '@pcscol/odf-api-v1-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { ObjetMaquetteUndoCommand } from './command';
import { CommandEvents } from './command-events';

/**
 * Cette commande ajoute un enfant à un objet maquette
 */
export class AjouterEnfantCommand extends ObjetMaquetteUndoCommand<ObjetMaquette> {
    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        private enfant: Enfant,
        private ignoreConflict: boolean
    ) {
        super(codeStructure, id, version, events, objetMaquetteService);
    }

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService.ajouterEnfant(this.id, this.enfant).pipe(tap(() => this.events.structureModifiee$.next(this.id)));
    }

    undo(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .retirerEnfant(this.id, this.enfant.id!, this.ignoreConflict)
            .pipe(tap(() => this.events.structureModifiee$.next(this.id)));
    }
}
